<template>
  <div class='vip-explain-wrap'>
    <div class='part' v-for="(item, index) in content" :key='index'>
      <div class='title a-text-15 a-lightblack fx-row fx-c-center'>
        <img src='https://cdn.133.cn/gtgj/vipcard/point.png' alt='' class='icon-point' />
        {{item.title}}
      </div>
      <div class='context-item a-text-14 a-gray' v-for="(conItem, idx) in item.con" :key='idx'>{{conItem}}</div>
    </div>
    <div class='part'>
      <div class='title a-text-15 a-lightblack fx-row fx-c-center'>
        <img src='https://cdn.133.cn/gtgj/vipcard/notice.png' alt='' class='icon-notice' />注意事项
      </div>
      <div class='context-item a-text-14 a-gray'>会员用户在使用会员福利的过程中，要严格遵守法律法规，不得利用漏洞，技术手段等刷取不当得利，一经发现，高铁管家有权取消该用户会员资格，且需要承担法律责任；</div>
      <div class='context-item a-text-14 a-gray'>在法律许可的范围内，高铁管家将根据需要对会员规则做调整包括升级条件及权益内容，如有重大调整，将通过push，短信或微信公众号等方式及时通知您。</div>
    </div>
  </div>
</template>

<script>
import vipExplainContent from '../../../../DATA/vipExplain';

export default {
  data () {
    return {
      content: []
    }
  },
  mounted () {
    let { level } = this.$route.params;
    this.content = [].concat(vipExplainContent[level] && vipExplainContent[level].list);
    this.$updateTitle(vipExplainContent[level] && vipExplainContent[level].type);
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.vip-explain-wrap {
  background: #F3F3F3;
  @mixin setSize($iWidth, $iHeight) {
    width: $iWidth * $px;
    height: $iHeight * $px;
  }
  .icon-point {
    @include setSize(12, 12);
    display: block;
    margin-right: 8 * $px;
  }
  .icon-notice {
     @extend .icon-point;
  }
  .part {
    background: #ffffff;
    padding-bottom: 16 * $px;
    .title {
      margin: 0 14 * $px 10 * $px;
    }
    .context-item {
      line-height: 20 * $px;
      padding: 0 14 * $px 8 * $px 45 * $px;
      position: relative;
      &::before {
        @include setSize(4, 4);
        display: block;
        content: '';
        background: #808080;
        border-radius: 50%;
        position: absolute;
        left: 34 * $px;
        top: 10 * $px;
        margin-top: -2 * $px;
      }
    }
    &:first-child {
      padding-top: 14 * $px;
    }
    &:last-child {
      margin-top: 8 * $px;
      .title {
        padding-top: 14 * $px;
      }
    }
  }
}

</style>





// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/vip-explain.vue